import { Injectable } from '@angular/core';
import { RestfulService } from '../rest/restful';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable()
export class ContactAndAddressService extends RestfulService<Models.AddressAssetModel> {
  constructor(private restService: RestService) {
    super(Models.AddressAssetModel);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('address-asset-models');
  }
}
